export default __webpack_public_path__ + "static/media/banner3.da1e36d4.png";